/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ trialDays: NonNullable<unknown> }} Try_Banner_Title_Free_DaysInputs */

const en_try_banner_title_free_days = /** @type {(inputs: Try_Banner_Title_Free_DaysInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`for ${i?.trialDays} days`)
};

const es_try_banner_title_free_days = /** @type {(inputs: Try_Banner_Title_Free_DaysInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`por ${i?.trialDays} días`)
};

/**
* | output |
* | --- |
* | "for {trialDays} days" |
*
* @param {Try_Banner_Title_Free_DaysInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const try_banner_title_free_days = /** @type {((inputs: Try_Banner_Title_Free_DaysInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Try_Banner_Title_Free_DaysInputs, { locale?: "en" | "es" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_try_banner_title_free_days(inputs)
	return en_try_banner_title_free_days(inputs)
});